<template>
    <v-container
        fluid
        class="py-0 px-0 my-2 mx-0"
    >
        <v-card outlined>
            <v-card-title>
                Generador de violencia  
                <v-spacer />
                <v-btn
                    class="float-md-right"                    
                    rounded
                    color="error"
                    small
                    @click="fnDeleteItem(idx)"
                >
                    <v-icon
                        small
                    >
                        mdi-delete
                    </v-icon>
                    Eliminar
                </v-btn>
            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-col
                        cols="12"
                        md="6"
                    >
                        <v-text-field
                            v-model="nombre"
                            label="Nombre de la persona que generó la violencia"
                            prepend-icon="mdi-account-circle"
                            @change="fnSetValue(idx, 'nombre', nombre)"
                        />
                    </v-col>
                    <v-col
                        cols="12"
                        md="6"
                    >
                        <select-rol-institucional
                            :fn-change="fnChangeRol"
                            :requerido="false"
                            etiqueta="Rol que tiene en la institución"
                        />
                    </v-col>
                </v-row>
                <v-row v-if="mostrarCampoNuaNue">
                    <v-col
                        cols="12"
                        :md="rolInstitucional.idRol == 1 ? 6 : 4"
                    >
                        <select-campus
                            :fn-change="fnChangeCampus"
                            :id-campus-prop="campus.id == null ? null : parseInt(campus.id)"
                            etiqueta="Campus / Colegio del Nivel Medio Superior / Dependencia administrativa"
                        />
                    </v-col>
                    <v-col
                        cols="12"
                        :md="rolInstitucional.idRol == 1 ? 6 : 4"
                    >
                        <select-division
                            :fn-change="fnChangeDivision"
                            :id-campus="campus.id == null ? null : parseInt(campus.id)"
                            etiqueta="División / Escuela"
                        />
                    </v-col>
                    <v-col
                        v-if="rolInstitucional.idRol != 1"
                        cols="12"
                        md="4"
                    >
                        <select-departamento
                            :fn-change="fnChangeDepartamento"
                            :id-division="division.id"
                        />
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </v-container>
</template>
<script>

export default {
    name: "InformacionGeneradorViolencia",
    components: {
        SelectRolInstitucional: () => import("../shared/SelectRolInstitucional"),
        SelectCampus: () => import("../shared/SelectCampus"),
        SelectDivision: () => import("../shared/SelectDivision"),
        SelectDepartamento: () => import("../shared/SelectDepartamento"),

    },
    props: {
        idx: {
            type: Number,
            required: true,
        },
        obj:{
            type: Object,
            required: true,
            default: () => ({ 
                rolInstitucional: { idRol: null, dscRol: null },
                nombre: '',
                campus: { id: null, descripcion: null }, 
                division: { id: null, descripcion: null }, 
                departamento: { id: null, descripcion: null } 
            })
        },
        fnSetValue: {
            type: Function,
            default: () => {}
        },
        fnDeleteItem: {
            type: Function,
            default: () => {}
        },
    },
    data () {
        return {
            valid: false,
            lazy: false,

            rolInstitucional: { idRol: null, dscRol: null },
            nombre: '',
            campus: { id: null, descripcion: null }, 
            division: { id: null, descripcion: null }, 
            departamento: { id: null, descripcion: null },
        }
    },
    computed: {
        mostrarCampoNuaNue () {
            if(this.rolInstitucional != null) {
                if(this.rolInstitucional.idRol == 1 || this.rolInstitucional.idRol == 2 || this.rolInstitucional.idRol == 3) {
                    return true;
                }
            }
            return false;
        },
    },
    watch: {
        obj: {
            handler (newValue, oldValue) {
                this.fnSetValuesProp();
            },
            deep: true,
            immediate: true 
        }, 
    },
    async mounted () {
      this.fnSetValuesProp();
    },
    methods: {
        fnSetValuesProp () {
          this.nombre = this.obj.nombre;
          this.rolInstitucional = this.obj.rolInstitucional;
          this.campus = this.obj.campus;
          this.division = this.obj.division;
          this.departamento = this.obj.departamento;
        },
        fnChangeRol (objRol) {
            this.rolInstitucional = objRol;
            this.fnSetValue(this.idx, 'rolInstitucional', this.rolInstitucional)
            this.campus = { id: null, descripcion: null };
            this.fnSetValue(this.idx, 'campus', this.campus)
        },
        fnChangeCampus (objCampus) {
            this.campus = objCampus;
            this.fnSetValue(this.idx, 'campus', this.campus)
            this.division = { id: null, descripcion: null };
            this.fnSetValue(this.idx, 'division', this.division)
        },
        fnChangeDivision (objDivision) {
            this.division = objDivision;
            this.fnSetValue(this.idx, 'division', this.division)
            this.departamento = { id: null, descripcion: null };
            this.fnSetValue(this.idx, 'departamento', this.departamento)
        },
        fnChangeDepartamento (objDepartamento) {
            this.departamento = objDepartamento;
            this.fnSetValue(this.idx, 'departamento', this.departamento)
        },
    },
}
</script>

<style scoped>

</style>